import React, { useState, useEffect } from 'react'
import { apiFetch } from '../services/api'
import { useAuth } from '../context/AuthContext'

const PLANES_DISPONIBLES = [
  {
    id: 'basico',
    nombre: 'Plan Emprendedor',
    precio: '$14.900 /mes',
    descripcion: 'Ideal para pequeñas tiendas que están iniciando.',
    caracteristicas: [
      'Hasta 1 Sucursal',
      'Hasta 2 Usuarios',
      'Hasta 500 Productos',
      'Soporte por Email',
      'Reportes básicos de ventas'
    ],
    destacado: false,
  },
  {
    id: 'pro',
    nombre: 'Pro PyME',
    precio: '$29.900 /mes',
    descripcion: 'Para negocios en crecimiento que necesitan gestión multi-sucursal.',
    caracteristicas: [
      'Hasta 5 Sucursales',
      'Hasta 10 Usuarios',
      'Productos Ilimitados',
      'Control de Stock Multi-sucursal',
      'Auditoría y Reportes Avanzados',
      'Soporte Prioritario WhatsApp'
    ],
    destacado: true,
  },
  {
    id: 'enterprise',
    nombre: 'Enterprise',
    precio: '$59.900 /mes',
    descripcion: 'Solución a medida para cadenas comerciales y distribuidores.',
    caracteristicas: [
      'Sucursales Ilimitadas',
      'Usuarios Ilimitados',
      'Productos Ilimitados',
      'Integraciones API & ERP',
      'Ejecutivo de Cuenta Dedicado',
      'SLA de Soporte 24/7'
    ],
    destacado: false,
  }
]

export default function Suscripcion() {
  const auth = useAuth() || {}
  const [uso, setUso] = useState(null)
  const [loading, setLoading] = useState(true)
  const [mensaje, setMensaje] = useState('')

  useEffect(() => {
    cargarDatosPlan()
  }, [])

  const cargarDatosPlan = async () => {
    setLoading(true)
    try {
      const data = await apiFetch('/empresa/plan')
      if (data && typeof data === 'object') {
        setUso(data)
      } else {
        setUso(null)
      }
    } catch (err) {
      console.warn('No se pudo obtener la información de la suscripción:', err)
      setUso(null)
    } finally {
      setLoading(false)
    }
  }

  const handleSolicitarCambio = (planNombre) => {
    if (uso?.plan_nombre === planNombre) {
      alert(`Actualmente ya te encuentras en el ${planNombre}.`)
      return
    }
    setMensaje(`¡Gracias! Hemos recibido tu solicitud para cambiar al ${planNombre}. Un ejecutivo te contactará en breve.`)
    setTimeout(() => setMensaje(''), 5000)
  }

  const sucUsadas = uso?.sucursales_usadas ?? 0
  const sucMax = uso?.sucursales_max ?? 1
  const sucPorcentaje = Math.min(100, Math.max(0, (sucUsadas / (sucMax || 1)) * 100))

  const usrUsados = uso?.usuarios_usados ?? 0
  const usrMax = uso?.usuarios_max ?? 1
  const usrPorcentaje = Math.min(100, Math.max(0, (usrUsados / (usrMax || 1)) * 100))

  const prodUsados = uso?.productos_usados ?? 0
  const prodMax = uso?.productos_max || 'Ilimitados'
  const prodPorcentaje = typeof prodMax === 'number' && prodMax > 0 
    ? Math.min(100, Math.max(0, (prodUsados / prodMax) * 100)) 
    : 100

  if (loading) {
    return (
      <div className="main-content">
        <div className="page-header"><h1 className="page-title">Mi Plan & Suscripción</h1></div>
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>Cargando información de tu suscripción...</div>
      </div>
    )
  }

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Mi Plan & Suscripción</h1>
        <p className="page-subtitle">Gestiona tu suscripción actual y conoce los límites de tu plan</p>
      </div>

      {mensaje && (
        <div style={{ padding: '1rem', background: '#dcfce7', color: '#15803d', borderRadius: '8px', marginBottom: '1.5rem', fontWeight: '500' }}>
          {mensaje}
        </div>
      )}

      {/* Tarjeta de Resumen de Uso */}
      <div className="card" style={{ marginBottom: '2rem', padding: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '1rem' }}>
          <div>
            <span style={{ fontSize: '0.875rem', color: '#64748b', fontWeight: '500' }}>Plan Actual</span>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0f172a', margin: '0.2rem 0 0 0' }}>
              {uso?.plan_nombre || 'Plan Emprendedor'}{' '}
              <span style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem', borderRadius: '999px', background: '#d1fae5', color: '#065f46', marginLeft: '0.5rem', verticalAlign: 'middle' }}>
                {uso?.estado || 'Activo'}
              </span>
            </h2>
          </div>
          <div style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>Próxima Renovación</span>
            <div style={{ fontWeight: '600', color: '#0f172a' }}>{uso?.proximo_pago || '—'}</div>
          </div>
        </div>

        <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem', color: '#334155' }}>Consumo de Recursos</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem' }}>
          {/* Sucursales */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem', marginBottom: '0.4rem' }}>
              <span style={{ color: '#64748b' }}>Sucursales</span>
              <span style={{ fontWeight: '600' }}>{sucUsadas} / {uso?.sucursales_max || '—'}</span>
            </div>
            <div style={{ background: '#e2e8f0', borderRadius: '999px', height: '8px', overflow: 'hidden' }}>
              <div style={{ background: '#2563eb', width: `${sucPorcentaje}%`, height: '100%' }} />
            </div>
          </div>

          {/* Usuarios */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem', marginBottom: '0.4rem' }}>
              <span style={{ color: '#64748b' }}>Usuarios</span>
              <span style={{ fontWeight: '600' }}>{usrUsados} / {uso?.usuarios_max || '—'}</span>
            </div>
            <div style={{ background: '#e2e8f0', borderRadius: '999px', height: '8px', overflow: 'hidden' }}>
              <div style={{ background: '#10b981', width: `${usrPorcentaje}%`, height: '100%' }} />
            </div>
          </div>

          {/* Productos */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem', marginBottom: '0.4rem' }}>
              <span style={{ color: '#64748b' }}>Productos</span>
              <span style={{ fontWeight: '600' }}>{prodUsados} ({prodMax})</span>
            </div>
            <div style={{ background: '#e2e8f0', borderRadius: '999px', height: '8px', overflow: 'hidden' }}>
              <div style={{ background: '#8b5cf6', width: `${prodPorcentaje}%`, height: '100%' }} />
            </div>
          </div>
        </div>
      </div>

      {/* Tabla Comparativa de Planes */}
      <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1.25rem', color: '#0f172a' }}>Planes Disponibles</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {PLANES_DISPONIBLES.map(plan => {
          const esPlanActual = uso?.plan_nombre === plan.nombre
          return (
            <div key={plan.id} className="card" style={{
              padding: '1.75rem',
              display: 'flex',
              flexDirection: 'column',
              justify: 'space-between',
              border: plan.destacado ? '2px solid #2563eb' : '1px solid #e2e8f0',
              position: 'relative',
              boxShadow: plan.destacado ? '0 10px 15px -3px rgba(37, 99, 235, 0.1)' : 'none'
            }}>
              {plan.destacado && (
                <span style={{
                  position: 'absolute',
                  top: '-12px',
                  right: '20px',
                  background: '#2563eb',
                  color: '#fff',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  padding: '0.2rem 0.75rem',
                  borderRadius: '999px'
                }}>
                  RECOMENDADO
                </span>
              )}

              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0f172a', margin: 0 }}>{plan.nombre}</h3>
                <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#2563eb', margin: '0.5rem 0' }}>{plan.precio}</div>
                <p style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '1.25rem', lineHeight: '1.4' }}>{plan.descripcion}</p>

                <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '1rem', marginBottom: '1.5rem' }}>
                  {plan.caracteristicas.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#334155', marginBottom: '0.5rem' }}>
                      <span style={{ color: '#10b981', fontWeight: 'bold' }}>✓</span> {item}
                    </div>
                  ))}
                </div>
              </div>

              <button
                className={`btn ${plan.destacado ? 'btn-primary' : 'btn-outline'}`}
                onClick={() => handleSolicitarCambio(plan.nombre)}
                disabled={esPlanActual}
                style={{ width: '100%', padding: '0.75rem', fontWeight: '600' }}
              >
                {esPlanActual ? 'Plan Actual' : (plan.id === 'enterprise' ? 'Contactar Ventas' : 'Cambiar a este plan')}
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}